<template>
	<div id="page-login" class="container-fluid h-100">
		<div class="d-flex justify-content-center align-items-center h-100">
			<div class="col-12 col-md-8">
				<div class="text-center mb-4"><!-- Bloc 1 LOGO -->
					<groomy-logo class="logo_center_bis" />
				</div>
				<div v-if="step !== 'password'" class="mb-4"><!-- Bloc 2 Login -->
					
					<div class="box box-dark">
						<div class="d-flex flex-wrap">
							<div class="col-12 col-lg-6">
								<div id="login" v-if="auto_connect || connecting" >
									<p class="text-center message_chargement mb-0 mt-4">
										<font-awesome-icon class="spinner_home" :icon="['far', 'spinner']" pulse /><br/>
									</p>
								</div>
								
								<div v-else>
									<template v-if="step == 'mail'">
										<h2>{{ $t('compte.connexion_inscription') }}</h2>
										<form @submit.prevent="checkMail">
											<div class="form-group">
												<label>{{ $t('compte.votre_email') }}</label>
												<input type="email" class="form-control" id="mail_user" v-model="login" required>
											</div>
											
											<div class="d-flex justify-content-end">
												<!-- <router-link :to="{name: 'CompteCreation', params: { email: login }}"  :title="$t('compte.je_nai_pas_de_compte')" class="btn btn-link btn-block btn-create w-50">{{ $t('compte.creer_compte') }} <font-awesome-icon :icon="['fal', 'angle-right']"/></router-link> -->
												<button type="submit" class="btn btn-primary w-50">{{ $t('global.suivant') }} <font-awesome-icon v-if="processing" pulse :icon="['fal', 'spinner']" /><font-awesome-icon v-else :icon="['fal', 'long-arrow-right']" /></button>
											</div>
											<hr />
											<ChoixLangue @language-changed="onLanguageChanged" />
									</form>
								</template>
								
								<template v-if="step == 'password_send'">
								
											<h2>{{ $t('compte.update_password_title') }}</h2>
											<p v-html="password_send_message"></p>
											<div class="d-flex justify-content-end">
												<b-button variant="primary" class="w-50" @click="backToMail">{{ $t('compte.back_login') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" /></b-button>
											</div>
						
								</template>
								
							<template v-if="step == 'autolog_sent'">
						
										<h2>{{ $t('compte.autolog_sent_title') }}</h2>
										<p v-html="getTrad('compte.autolog_sent_message', [login])"></p>
										<div class="d-flex justify-content-end">
											<b-button variant="primary" class="w-50" @click="backToMail">{{ $t('compte.back_login') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" /></b-button>
										</div>
					
							</template>
									
									
									
								</div>
							</div>
							<div class="col-12 col-lg-6">
								<h2>{{ $t('compte.welcome') }}</h2>
								<p v-if="welcome_loaded" v-html="welcome_message || $t('compte.texte_creant_compte_info')"></p>
								<p v-else class="text-muted"><font-awesome-icon :icon="['fal', 'spinner']" pulse /></p>
							</div>
						</div>
					</div>
					
				</div>
				
				
				<div v-if="step == 'password'" class="mb-4"><!-- Bloc 3 Password -->
					
					<div  class="box box-dark">
						<div class="d-flex flex-wrap">
							<div class="col-12 col-lg-6">
								<h2>{{ $t('compte.connexion') }}</h2>
								
								<form @submit.prevent="submitLogs">
									<div class="form-group">
										<label>{{ $t("compte.password") }}</label>
										<input type="password" class="form-control" id="password_user" v-model="password">
										<div v-if="invalid_password && error_message" class="alert alert-warning mt-1">{{ error_message }}</div>
									</div>
									
									<div class="text-right">
										<button type="submit" class="btn btn-primary w-50">{{ $t('compte.connexion') }} <font-awesome-icon v-if="processing" pulse :icon="['fal', 'spinner']" /><font-awesome-icon v-else :icon="['fal', 'long-arrow-right']" /></button>
									</div>
									<hr />
									<ChoixLangue @language-changed="onLanguageChanged" />
								</form>
							</div>
							<div class="col-12 col-lg-6" id="col2">
								<template v-if="processing_password || processing_autolog">
									<p class="text-center message_chargement mb-0 mt-4">
										<font-awesome-icon class="spinner_home" :icon="['far', 'spinner']" pulse /><br/>
									</p>
								</template>
								<template v-else>
									<h2>{{ $t('compte.mdp_oublie') }}</h2>
									<ul>
										<li>
											<a href="#" @click.prevent="sendPassword">{{ $t('compte.update_password') }}</a>
										</li>
										<li>
											<a href="#" @click.prevent="autolog">{{ $t('compte.lien_connexion') }}</a>
										</li>
									</ul>
								</template>
							</div>
						</div>
					</div>
				</div>
				
				
			</div>
			
			
		</div>
	</div>
</template>


<script type="text/javascript">
import Vue from 'vue'
import Constants from 'Constants'
import UserMixin from '@/mixins/User.js'
import Navigation from '@/mixins/Navigation.js'
import Config from '@/mixins/Config.js'
import { loadI18nPlugin } from 'GroomyRoot/assets/js/i18n.js'
import Countries from '@/assets/lang/countries/countries'

export default {
	name: "Home",
	mixins: [UserMixin, Navigation, Config],
	data () {
		return {
			reset_pwd_url: Constants.WEBAPP_GROOMY_URL + "/#/reset_password?ca=" + window.location.href,
			login: '',
			password: '',
			autolog_token: '',
			redirect: '',
			welcome_message: '',
			welcome_loaded: false,
			connecting: false,
			auto_connect: false,
			clicked_groomy: false,
			error_message: "",
			step: 'mail',
			processing: false,
			countries_iso_array: [],
			name: '',
			firstname: '',
			country: '',
			phone: {
				phone_indicatif: '+33',
				phone_numero: '',
				phone_country: "FR"
			},
			invalid_password: false,
			errors: [],
			message_erreur_code: '',
			processing_password: false,
			processing_autolog: false,
			password_send_message: ''
		}
	},
	created() {
		if(this.$route.query.redirect) {
			this.redirect = this.$route.query.redirect
			this.welcome_loaded = true
		}
		else {
			this.getRedirectUrl(Vue.i18n.locale()).then(res => {
				if(res.retour.redirect != null) {
					this.redirect = res.retour.redirect
				}
				if(res.retour.welcome_message) {
					this.welcome_message = res.retour.welcome_message
				}
				this.welcome_loaded = true
			}).catch(() => {
				this.welcome_loaded = true
			})
		}
		if(this.$route.query.mail) {
			this.login = this.$route.query.mail
		}
		
		if(this.$route.query.lastname) {
			this.name = this.$route.query.lastname
			this.step = 'creation'
		}
		
		if(this.$route.query.firstname) {
			this.firstname = this.$route.query.firstname
			this.step = 'creation'
		}
		
		if(this.$route.query.phone) {
			this.phone.phone_numero = this.$route.query.phone
			this.step = 'creation'
		}
		
		if(this.$route.query.lang) {
			this.setLanguage(this.$route.query.lang)
		}

		if(this.$route.query.als) {
			this.auto_connect  = true
			this.autolog_token = this.$route.query.als
			
			this.submitAutoLog(this.login, this.autolog_token)
			.then(() => {
				this.redirectPostLogin(this.redirect)
			})
			.catch(() => {
				this.returnToLogin()
			})
		}
		this.loadCountries()
	},
	mounted() {
		this.$nextTick(() => {
			const mailInput = document.getElementById('mail_user')
			if (mailInput) mailInput.focus()
		})
	},
	methods: {
		async submitLogs() {
			if(this.login != '' && this.password != '') {
				this.processing = true
				this.connecting = true
				this.invalid_password = false
				this.error_message = ''
				
				try {
					await this.loginUser(this.login, this.password, this.redirect, true)
				} 
				catch (err) {
					this.error_message = err.message
					this.invalid_password = true
					this.returnToLogin()
				}
			}
		},
		returnToLogin() {
			this.processing = false
			this.auto_connect = false
			this.connecting = false
		},
		async checkMail() {
			this.processing = true
			let result = await this.checkIfAdressMailExists(this.login)
			this.processing = false
			
			if(!result || !result.exists) {
				// Email n'existe pas -> création de compte
				this.$router.push({name: 'CompteCreation', params: { email: this.login }})
			} else if(result.exists && !result.email_verified) {
				// Email existe mais non vérifié -> validation email
				//this.$router.push({name: 'EmailValidation', params: { email: this.login }})

				// pour le moment on garde la même méthode et on propose l'identification
				this.step = 'password'
			} else {
				// Email existe et vérifié -> login
				this.step = 'password'
			}
		},
		setLangue(lang) {
			this.setConfig('lang', lang)
			loadI18nPlugin(lang)
			this.$emit('langue_choosed')
		},
		backToMail() {
			this.step = 'mail'
		},
		goToCreate() {
			this.step = 'creation'
		},
		goToPasswordSend() {
			this.step = 'password_send'
		},
		goToAutologSent() {
			this.step = 'autolog_sent'
		},
		loadCountries() {
			this.countries = Countries[Vue.i18n.locale()].label
			this.countries_iso = Countries[Vue.i18n.locale()].iso_3
			
			let countries_values = Object.values(this.countries)
			let countries_iso_values = Object.values(this.countries_iso)
			
			let temp = []
			for (let i = 0; i < countries_values.length; i++) {
				temp.push(countries_values[i])
			}
			
			let countries_iso_array_temp = []
			let countries_keys = Object.keys(this.countries)
			let countries_formatted = Object.fromEntries(countries_keys.map((_, i) => [countries_keys[i], temp[i]]))
			
			for (let [key, value] of Object.entries(countries_formatted)){
				countries_iso_array_temp.push({
					id: key,
					name: value,
					iso: this.countries_iso[key]
				})
			}
			this.countries_iso_array = countries_iso_array_temp.sort((a,b) => {
				let x = this.accentsTidy(a.name.toLowerCase());
				let y = this.accentsTidy(b.name.toLowerCase());
				return x < y ? -1 : x > y ? 1 : 0;
			});
			
			this.country = countries_iso_array_temp.find(country => country.iso == "FRA")
			
			if(this.$route.query.country) {
				this.country = countries_iso_array_temp.find(country => country.id == this.$route.query.country)
			}
		},
		async validForm() {
			let user = {
				name: this.name,
				firstname: this.firstname,
				mail: this.login,
				password: this.password,
				password_confirmation: this.password,
				indicatif: this.phone.phone_indicatif,
				phone: this.phone.phone_numero,
				// Code ISO à 3 lettre ne fonctionne pas pour les numéros de téléphone, merci à tous
				country: this.phone.phone_country.slice(0, 2)
			}
			this.message_erreur_code = ''
			
			this.processing = true
			let res = await this.createUser(user, 'client_area')
			if(res.code_retour) {
				// this.$cache.user_id = res.retour.id
				await this.setConfig("user_id", res.retour.id)
				
				const result_login = await this.checkLogin(this.login, this.password)
				if(result_login){
					this.$router.push({ name: 'EmailValidation' })
				}
			}
			else {
				this.message_erreur_code = res.retour
			}
			this.processing = false
		},
		
		async autolog() {
			this.processing_autolog = true
			try {
				const lang = Vue.i18n.locale()
				await this.sendAutolog(this.login, lang)
				this.goToAutologSent()
			} catch (e) {
				this.failureToast()
			} finally {
				this.processing_autolog = false
			}
		},
		
		checkSpecialChar() {
			this.errors = []
			var format = /^[A-Z- ]*$/;
			if(!format.test(this.name)) {
				this.errors.push('name')
			}
			if(!format.test(this.firstname)) {
				this.errors.push('firstname')
			}
		},
		
		sendPassword() {
			this.processing_password = true
			const lang = this.getConfig('lang') ?? 'fr'
			this.$request.request_post_api("ResetPassword::validForm", Constants.RESET_PWD_URL_API, {email: this.login, lang: lang}, false)
			.then((response_register) => {
				this.processing_password = false
				if(response_register.code_retour == 0) {
					this.goToPasswordSend()
					this.password_send_message = this.getTrad('compte.update_password_text', [this.login])
				}
			})
		},
		onLanguageChanged(lang) {
			this.getRedirectUrl(lang).then(res => {
				if(res.retour.welcome_message) {
					this.welcome_message = res.retour.welcome_message
				}
			})
		}
	},
	computed: {
		verrouAutoConnect: function() {
			return this.auto_connect || this.connecting
		},
		verrouManualConnect: function() {
			return this.connecting
		}
	},
	watch: {
		name(val) {
			this.name = val.toUpperCase()
			this.checkSpecialChar()
		},
		firstname(val) {
			this.firstname = val.toUpperCase()
			this.checkSpecialChar()
		},
		step(val) {
			if(val === 'password') {
				this.$nextTick(() => {
					document.getElementById('password_user').focus()
				})
			}
		}
	},
	components: {
		PhoneInput : () => import('GroomyRoot/components/Inputs/PhoneInput'),
		ChoixLangue: () => import('@/components/ChoixLangue'),
	}
};
</script>
